export default __webpack_public_path__ + "static/media/hexagon-pattern-bg.42fc68df.svg";